





















import Vue from 'vue'

import RelatedLinks from '@/common/components/RelatedLinks.vue'
import MagazineCarousel from '@/common/components/magazine/MagazineCarousel.vue'
import { MAGAZINE_TYPES } from '@/magazine/consts'
import { CmsCategory, CmsMagazine, CmsMappingTypeEnum } from '@/types/graphqlQuery'
import { RelatedLink } from '@/common/types'
import { getCMSLinks } from '@/common/service'

export default Vue.extend({
  components: {
    RelatedLinks,
    MagazineCarousel
  },
  data(): {
    cmsCategories: RelatedLink[],
    cmsMagazines: CmsMagazine[]
  } {
    return {
      cmsCategories: [],
      cmsMagazines: []
    }
  },
  computed: {
    categoryId(): string | undefined {
      return this.$store.state.productDetail.product.categoryId
    },
    MAGAZINE_TYPES(): { [key: string]: string } {
      return MAGAZINE_TYPES
    }
  },
  created() {
    this.getRelatedCmsData()
  },
  methods: {
    async getRelatedCmsData() {
      const cmsData = await getCMSLinks(CmsMappingTypeEnum.Category, [this.categoryId as string])
      if (cmsData) {
        this.cmsCategories = cmsData?.cmsMapping?.cmsCategories.map((item: CmsCategory) => ({
          name: item.h1,
          url: item.url
        }))
        this.cmsMagazines = cmsData?.cmsMapping?.cmsMagazines
      }
    }
  }
})
